'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@/app/components/button';
import { IconInfo } from '@/app/components/icons/common-actions/icon-info';
import { Image } from '@/app/components/media/image';
import { Tooltip } from '@/app/components/overlays/tooltip';
import styles from '@/app/components/sections/service/parts/styles.module.css';
import { type GenuinePartItemProps } from '@/app/components/sections/service/parts/types';
import { GENUINE_PARTS } from '@/app/contents/service/parts';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { formatPrice, getPartPrefix } from '@/app/utils/format';
import { type ComponentServicesGenuinePart, Enum_Componentservicesgenuinepart_Genuineparttype } from '@/types/tis-cms/types';
const getLogo = (genuinePart: ComponentServicesGenuinePart) => {
  switch (genuinePart?.genuinePartType) {
    case Enum_Componentservicesgenuinepart_Genuineparttype.Tripetch:
      return GENUINE_PARTS.tripetchGenuinePart;
    case Enum_Componentservicesgenuinepart_Genuineparttype.Bvp:
      return GENUINE_PARTS.bvpGenuinePart;
    default:
      return GENUINE_PARTS.isuzuGenuinePart;
  }
};
export const GenuinePartItem = t0 => {
  const $ = _c(48);
  const {
    genuinePart,
    index,
    testId
  } = t0;
  useState(false);
  if (!genuinePart) {
    return null;
  }
  let t1;
  if ($[0] !== genuinePart) {
    t1 = getLogo(genuinePart);
    $[0] = genuinePart;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const logo = t1;
  const t2 = `${testId}-part-${index}`;
  let t3;
  if ($[2] !== t2) {
    t3 = createDataAttributes({
      test: t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== genuinePart || $[5] !== index || $[6] !== logo.alt || $[7] !== logo.dimension || $[8] !== logo.src || $[9] !== logo.type || $[10] !== testId) {
    t4 = !!genuinePart && <div className="flex flex-1 items-center justify-center"><div className={cn("relative", {
        [styles.isuzuGenuinePartLogo]: logo.type === "isuzu-logo",
        [styles.tripetchGenuinePartLogo]: logo.type === "tripetch-logo",
        [styles.bvpGenuinePartLogo]: logo.type === "bvp-logo"
      })} {...createDataAttributes({
        test: `${testId}-part-${index}-logo`
      })}><Image src={logo.src} alt={logo.alt} width={logo.dimension.width} height={logo.dimension.height} layout="ratio" aspectRatio="calculate" /></div></div>;
    $[4] = genuinePart;
    $[5] = index;
    $[6] = logo.alt;
    $[7] = logo.dimension;
    $[8] = logo.src;
    $[9] = logo.type;
    $[10] = testId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== genuinePart) {
    t5 = genuinePart ? getPartPrefix(genuinePart) : "";
    $[12] = genuinePart;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = `${t5}`;
  let t7;
  if ($[14] !== t6) {
    t7 = {
      __html: t6
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `${testId}-part-${index}-title`;
  let t9;
  if ($[16] !== t8) {
    t9 = createDataAttributes({
      test: t8
    });
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <p className="text-body-1 font-noto-bold where-span:text-inline-wrap text-gray-800 xl:text-center" dangerouslySetInnerHTML={t7} {...t9} />;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = genuinePart?.price ?? "";
  let t12;
  if ($[21] !== t11) {
    t12 = formatPrice(t11, "none");
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = `${genuinePart?.showStartPricePrefix ? "\u0E40\u0E23\u0E34\u0E48\u0E21" : " "} ${t12} ${genuinePart?.unit ?? ""}`;
  let t14;
  if ($[23] !== t13) {
    t14 = {
      __html: t13
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = `${testId}-part-${index}-price-unit`;
  let t16;
  if ($[25] !== t15) {
    t16 = createDataAttributes({
      test: t15
    });
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <p className="text-body-1 font-noto-bold md:text-body-1-fixed text-red-500" dangerouslySetInnerHTML={t14} {...t16} />;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t10 || $[31] !== t17) {
    t18 = <div className="flex flex-1 flex-col items-start justify-center xl:items-center">{t10}{t17}</div>;
    $[30] = t10;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== logo.title) {
    t19 = <div className="font-noto-bold mb-3" dangerouslySetInnerHTML={{
      __html: logo.title
    }} />;
    $[33] = logo.title;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== logo.description) {
    t20 = !!logo.description && <div className="whitespace-pre-wrap" dangerouslySetInnerHTML={{
      __html: logo.description
    }} />;
    $[35] = logo.description;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <div className="from-silver-50 min-w-78 rounded-md bg-linear-180 to-white p-4 shadow-lg md:min-w-84">{t19}{t20}</div>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Button iconBefore={<IconInfo />} variant="tertiary" size="xs" className="text-azure-600 hover:text-azure-700 -z-10 inline-block size-8 cursor-pointer rounded-full p-2" />;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t21) {
    t23 = <div className="absolute top-0 right-0"><Tooltip placement="top-right" wrapperClassName="z-30" arrowClassName="text-white" element={t21}>{t22}</Tooltip></div>;
    $[41] = t21;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t18 || $[44] !== t23 || $[45] !== t3 || $[46] !== t4) {
    t24 = <div className="bg-silver-50 relative flex flex-1 flex-row items-center justify-center gap-4 rounded-md border border-gray-50 p-3 md:rounded-lg xl:flex-col xl:p-4 2xl:p-5" {...t3}>{t4}{t18}{t23}</div>;
    $[43] = t18;
    $[44] = t23;
    $[45] = t3;
    $[46] = t4;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  return t24;
};